import styled, { css, Sizes } from 'styled-components';

type Variants = 'plain' | 'normal';

export type DLProps = {
  mt?: Sizes;
  mb?: Sizes;
  py?: Sizes;
  px?: Sizes;
  variant?: Variants;
};

export const DL = styled.dl<DLProps>`
  display: grid;
  grid-template-columns: auto minmax(100px, 100%);
  border-top: 1px solid rgba(0, 0, 0, 0.04);

  dt,
  dd {
    padding-top: ${({ theme, py }) => theme.sizes[py || 'normedium']};
    padding-bottom: ${({ theme, py }) => theme.sizes[py || 'normedium']};
    padding-left: ${({ theme, px }) => theme.sizes[px || 'large']};
    padding-right: ${({ theme, px }) => theme.sizes[px || 'large']};
  }

  dt:not(:last-of-type),
  dd:not(:last-of-type) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }

  ${({ mt, theme }) =>
    mt &&
    css`
      margin-top: ${theme.sizes[mt]};
    `};

  ${({ mb, theme }) =>
    mb &&
    css`
      margin-bottom: ${theme.sizes[mb]};
    `};

  ${({ variant }) =>
    variant === 'plain' &&
    css`
      border: none;

      dd,
      dt,
      dt:not(:last-of-type),
      dd:not(:last-of-type) {
        border: none;
      }

      dt {
        background: none;
        padding-left: 0;
      }

      dd {
        padding-right: 0;
      }
    `}
`;

export const DT = styled.dt`
  background-color: rgba(0, 0, 0, 0.02);
  color: ${({ theme }) => theme.palette.greyBlack.main};
  font-weight: bold;
`;

export const DD = styled.dd`
  display: flex;
  align-items: center;

  & pre {
    margin: 0;
    font-size: ${({ theme }) => theme.sizes.small};
  }
`;
